import styled from '@emotion/styled';
import { Magnetic } from "../../../styles";
export const StyledDivContentContainer = styled('div')((props) => `
    background-color: ${props.speechBubbleBackgroundColor};
    text-align: center;
    position: relative; 
    box-shadow: ${Magnetic.boxShadow01};
    padding: ${Magnetic.whiteLabelMobileSpeechBoxPadding};
    border-radius: ${Magnetic.whiteLabelMobileSpeechBoxBorderRadius};
    & ::after {
        content: '';
        position: absolute;
        bottom: 100%;
        width: 0;
        height: 0;
        border-left:${Magnetic.spacer20} ${Magnetic.baseBorderStyle} transparent;
        border-right:${Magnetic.spacer20} ${Magnetic.baseBorderStyle} transparent;
        border-bottom:${Magnetic.spacer20} ${Magnetic.baseBorderStyle} ${props.speechBubbleBackgroundColor};
        left: calc(50% - ${Magnetic.spacer20});
        right: calc(50% - ${Magnetic.spacer20});
      }
      & p {
        font-size:${Magnetic.fontSize16};
        text-align: left;
        line-height: ${Magnetic.spacer24}; 
        margin-block-start: 0;
        margin-block-end: 0;
      }
`);
export const StyledInstructions = styled('div') `
	ul,
	ol {
		list-style-position: inside;
	}

	ul {
		list-style-type: disc;
	}

	ol {
		list-style-type: decimal;
	}
`;
//# sourceMappingURL=WhiteLabelMobileSpeechBox.style.js.map